import { SubTaskQuestionTemplateQuestionRating } from '@dadohr/shared/domainTypes/experience';
import { Rating } from '@material-ui/lab';
import React from 'react';
import { useUnsafeTranslation } from '../../i18next';

/**
 * Star rating for Rating questions (1..max). Used by the admin preview
 * (readOnly) and the employee app. MUI's Rating reports `null` when the
 * selected star is clicked again; that is ignored so an answer can't be
 * cleared by accident — the participant picks a different star instead.
 */
export const RatingInput = ({
  question,
  value,
  onChange,
  name,
  id,
  disabled,
  readOnly
}: {
  question: SubTaskQuestionTemplateQuestionRating;
  value: number | null;
  onChange?: (next: number) => void;
  name: string;
  id?: string;
  disabled?: boolean;
  readOnly?: boolean;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <Rating
      id={id}
      name={name}
      max={question.max}
      value={value}
      size="large"
      disabled={disabled}
      readOnly={readOnly}
      getLabelText={(v) =>
        t('{{ value }} of {{ max }} stars', { value: v, max: question.max })
      }
      onChange={(_ev, next) => {
        if (readOnly || !onChange || next === null) {
          return;
        }
        onChange(next);
      }}
    />
  );
};
